import * as React from "react"

const SvgForm = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 20.286q-.824 0-1.413-.588A1.93 1.93 0 0 1 3 18.286v-12q0-.825.587-1.413A1.93 1.93 0 0 1 5 4.286h14q.824 0 1.413.587.587.588.587 1.413v12q0 .825-.587 1.412a1.93 1.93 0 0 1-1.413.588zm0-2h14v-10H5zm3-6a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712.97.97 0 0 1 .287-.713.97.97 0 0 1 .713-.287h8a.97.97 0 0 1 .712.287q.288.288.288.713c0 .425-.096.52-.288.712a.97.97 0 0 1-.712.288zm0 4a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712.97.97 0 0 1 .287-.713.97.97 0 0 1 .713-.287h4q.424 0 .713.287.287.288.287.713c0 .425-.096.52-.287.712a.97.97 0 0 1-.713.288z" />
  </svg>
)
export default SvgForm
